export const validateKana = (input: string) => {
    return input.trim().match(/^[ァ-ヶー]+$/) !== null;
};

export const validateMobilePhoneNumber = (input: string) => {
    return input.trim().match(/^(?:\d{11}|\d{3}-\d{4}-\d{4})$/) !== null;
};

export const validatePhoneNumber = (input: string) => {
    return input.trim().match(/^(?:\d{10,11}|(?=(?:\D*\d){10,11}\D*$)\d+(?:-\d+){2})$/) !== null;
};

export const validateEmail = (input: string) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(input);
};
